import styles from "./Footer.module.scss";
import React, { FC } from "react";

export const Footer: FC = () => {
    return <div className={styles.footer} />;
};
